import "./Signin.css";
import "../components/fonts.css";
import logo from "../assets/logo.png";
import Submit_button from "../components/submit_button.js";
import Header from "../components/header.js";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, Toast, Toaster } from "react-hot-toast";

function Signin() {
  const [email, SetEmail] = useState("");
  const [password, SetPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  const handleEmailInputChange = (event) => {
    SetEmail(event.target.value);
  };

  const handlePasswordInputChange = (event) => {
    SetPassword(event.target.value);
  };

  function handleCheckboxChange(event) {
    setIsChecked(event.target.checked);
  }

  const handleSubmit = (event) => {
    if (email.length === 0) {
      toast.error("Please enter your email !");
    } else if (password.length === 0) {
      toast.error("Please enter your password !");
    } else {
      login(event);
    }
  };

  const login = (event) => {
    event.preventDefault();
    fetch(
      "https://happer-test.francecentral.cloudapp.azure.com/api/users/influencer/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          toast.error(data.message);
          localStorage.setItem("jwtToken", data.user.token);
          localStorage.setItem("refreshToken", data.user.refresh_token);
          navigate("/top_outfits");
        } else {
          toast.error("No data returned !");
          return;
        }
      })

      .catch((error) => console.log(error.message));
  };

  return (
    <>
      <Header user="influencer" title="S'inscrire" />
      <div className="Signin">
        <Toaster toastOptions={{ duration: 2000 }} />
        <img className="Happer_image" src={logo} alt="Happer LOGO" />
        <p className="Happer_text">
          La plateforme monétisation mode
          <br />
          des créateurs de contenu
        </p>
        <input
          type="text"
          name="phone-number"
          value={email}
          onChange={handleEmailInputChange}
          placeholder="Nom d'utilisateur"
          required
        />
        <input
          type="password"
          name="phone-number"
          value={password}
          onChange={handlePasswordInputChange}
          placeholder="Mot de passe"
          required
        />
        <label className="remember_me">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          Se souvenir de moi
        </label>
        <Submit_button title="Se connecter" onClick={handleSubmit} />
        <p className="oubier_mdps">Mot de passe oublie?</p>
      </div>
    </>
  );
}

export default Signin;
